/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { filter, map, unique } from './arrays';
import { pipe } from './functions';
import { ensureArray, flatMap, isArray, isObject, isPlainObject, isUndefined } from './index';
export function entries(...args) {
    if (args.length === 1) {
        const data = args[0];
        const objectKeys = Object.keys(data);
        return objectKeys.map((key) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const o = data;
            return [key, o[key]];
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (data) => {
        const objectKeys = Object.keys(data);
        return objectKeys.map((key) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const o = data;
            return [key, o[key]];
        });
    };
}
export function fromEntries(data) {
    if (!data) {
        return (d) => {
            return fromEntries(d);
        };
    }
    // @ts-ignore
    return data.reduce((acc, current) => {
        return Object.assign({}, acc, { [current[0]]: current[1] });
    }, {});
}
export function mapRecordEntries(fn, data) {
    if (!data) {
        return (d) => {
            return mapRecordEntries(fn, d);
        };
    }
    return pipe(data, entries(), map(([key, value]) => {
        return fn(key, value);
    }), fromEntries());
}
export function keys(data) {
    if (!data) {
        return (d) => {
            return keys(d);
        };
    }
    return Object.keys(data);
}
export function pluck(select, data) {
    if (!data) {
        return (d) => {
            return pluck(select, d);
        };
    }
    const uKeys = pipe(select, unique());
    return Object.assign({}, ...uKeys.map((key) => {
        return {
            [key]: data[key],
        };
    }));
}
export function omit(emit, data) {
    if (!data) {
        return (d) => {
            return omit(emit, d);
        };
    }
    const iRawKeys = pipe(data, keys(), filter((k) => !emit.includes(k)));
    return pluck(iRawKeys, data);
}
export function reduceRecord(fn, initial, data) {
    if (!data) {
        return (d) => reduceRecord(fn, initial, d);
    }
    const c = Object.keys(data);
    return c.reduce((acc, key) => {
        const value = data[key];
        return fn(acc, value, key, data);
    }, initial);
}
export function mapToObject(fn, data) {
    if (!data) {
        return (q) => {
            return Object.assign({}, ...q.map((k, index, arr) => {
                return { [k]: fn(k, index, arr) };
            }));
        };
    }
    return Object.assign({}, ...data.map((k, index, arr) => {
        return { [k]: fn(k, index, arr) };
    }));
}
export function mapToRecord(fn, data) {
    if (!data) {
        return (q) => {
            return Object.assign({}, ...q.map((k, index, arr) => {
                return { [k]: fn(k, index, arr) };
            }));
        };
    }
    return Object.assign({}, ...data.map((k, index, arr) => {
        return { [k]: fn(k, index, arr) };
    }));
}
export function mapRecord(fn, data) {
    if (!data) {
        return (d) => {
            return mapRecord(fn, d);
        };
    }
    return Object.assign({}, ...Object.keys(data).map((key) => {
        return {
            [key]: fn(data[key], key, data),
        };
    }));
}
/**
 * Filter record values
 */
// @ts-ignore
export function filterRecordValues(fn) {
    return (data) => {
        return pipe(data, filterRecord((v) => {
            return fn(v);
        }));
    };
}
export function filterRecord(fn, data) {
    if (!data) {
        return (d) => {
            return filterRecord(fn, d);
        };
    }
    return pipe(data, entries(), filter(([key, value]) => fn(value, key)), fromEntries());
}
export function flatMapRecordEntries(fn, data) {
    if (!data) {
        return (d) => {
            return flatMapRecordEntries(fn, d);
        };
    }
    return Object.assign({}, ...Object.keys(data).map((key) => {
        const q = pipe(fn(data[key], key, data), fromEntries());
        return Object.assign({}, q);
    }));
}
export function values(...args) {
    if (args.length === 1) {
        return Object.keys(args[0]).reduce((acc, key) => {
            const k = key;
            const d = args[0][k];
            return [...acc, d];
        }, []);
    }
    return (data) => {
        return Object.keys(data).reduce((acc, key) => {
            const k = key;
            const d = data[k];
            return [...acc, d];
        }, []);
    };
}
// tslint:disable-next-line: readonly-array
export function combine(...args) {
    return (data) => {
        return args.reduce((acc, current) => {
            return Object.assign({}, acc, current(data));
        }, {});
    };
}
export function extract(fn, defaultValue) {
    return (data) => {
        // tslint:disable-next-line: no-try
        try {
            const f = fn(data);
            if (typeof f === 'undefined' || f === null) {
                return defaultValue;
            }
            return f;
        }
        catch (_a) {
            if (defaultValue) {
                return defaultValue;
            }
            return;
        }
    };
}
/**
 * Removes null and undefined values from object recursively
 */
export function noNullNoUndefinedInObject(a) {
    return Object.assign({}, ...Object.entries(a)
        .filter(([, v]) => v !== undefined && v !== null)
        .map(([k, v]) => ({
        [k]: Array.isArray(v)
            ? v
                .filter((val) => val !== undefined && val !== null)
                .map((val) => (isPlainObject(val) ? noNullNoUndefinedInObject(val) : val))
            : isPlainObject(v)
                ? noNullNoUndefinedInObject(v)
                : v,
    })));
}
/**
 * Sorts object orr array
 * @deprecated - Use
 * @param x
 */
export function sortKeys(x) {
    if (typeof x !== 'object' || !x) {
        return x;
    }
    const data = x;
    if (Array.isArray(data)) {
        return data.map((e) => {
            // tslint:disable-next-line: deprecation
            return sortKeys(e);
        });
    }
    // tslint:disable-next-line: no-array-mutation
    return Object.keys(data)
        .sort()
        // tslint:disable-next-line: deprecation
        .reduce((o, k) => (Object.assign({}, o, { [k]: sortKeys(data[k]) })), {});
}
/**
 * Parse multi level list of data to one level list of strings optimized for the search
 * @example
 * ```typescript
 *  toFlatArray([[{'a': 1, 'b': 2}]]) // ['a 1', 'b 2']
 * ```
 */
export function toFlatArray(value) {
    if (isArray(value)) {
        return pipe(value, flatMap(toFlatArray));
    }
    if (isObject(value)) {
        return pipe(Object.entries(value), flatMap(([k, v]) => {
            return pipe(ensureArray(v), flatMap((v1) => {
                return pipe(toFlatArray(v1), flatMap((v2) => {
                    return [`${k} ${toFlatArray(v2)}`];
                }));
            }));
        }));
    }
    if (isUndefined(value)) {
        return [''];
    }
    return [String(value == null ? '' : value)];
}
